import store from './store';
var hasAccessToken = function () {
    var accessToken = store.get('accessToken', 'session');
    return !!accessToken;
};
export default hasAccessToken;
